import React, { FunctionComponent } from "react";
import { Close, HelpDrawer } from "@cmsgov/ds-medicare-gov";
import medicareCard from "../assets/medicare-sample-card.png";
import { useTranslate } from "../helpers";
import { FormattedMessage } from "react-intl-phraseapp";

const MedicareCardHelpDrawer: FunctionComponent<{
  onCloseClick: () => void;
}> = ({ onCloseClick }) => {
  const t = useTranslate();

  return (
    <div className="mct-c-help-drawer">
      <HelpDrawer
        title={t("medicare_help_drawer.title")}
        onCloseClick={onCloseClick}
        closeButtonText={<Close />}
      >
        <p>{t("medicare_help_drawer.check_your_red")}</p>
        <p>
          <FormattedMessage
            id="medicare_help_drawer.if_new"
            values={{
              loggingIntoYourSsAccount: (
                <a
                  href="https://www.ssa.gov/myaccount/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("medicare_help_drawer.logging_into_ss_account")}
                </a>
              ),
            }}
          />
        </p>

        <img
          className="MedicareHelpDrawer__image ds-u-margin-top--2"
          src={medicareCard}
          alt={t("landing_page.medicare_card_alt_text")}
        />
      </HelpDrawer>
    </div>
  );
};

export default MedicareCardHelpDrawer;
